import { ERROR_HTML, SUCCESS_HTML } from '../pages'
import type { Route } from '../types'

// Where the console sends the browser once the user has authorized the CLI and picked a workspace. The
// request carries either an exchange code or an error; both end the wait, and both render a page telling
// the user they can close the window.

export interface CallbackRoute {
  route: Route
  waitForCode: () => Promise<string>
}

export function callbackRoute(path = '/callback'): CallbackRoute {
  let resolveCode: ((code: string) => void) | null = null
  let rejectCode: ((error: Error) => void) | null = null

  const respond = (route: Parameters<Route['handle']>[0], html: string) => {
    route.res.writeHead(200, { 'Content-Type': 'text/html' })
    route.res.end(html)
  }

  const route: Route = {
    method: 'GET',
    path,
    handle: context => {
      const code = context.url.searchParams.get('code')
      const error = context.url.searchParams.get('error')

      if (error) {
        respond(context, ERROR_HTML(error))
        rejectCode?.(new Error(error))

        return
      }

      if (!code) {
        respond(context, ERROR_HTML('Missing exchange code'))
        rejectCode?.(new Error('Missing exchange code'))

        return
      }

      respond(context, SUCCESS_HTML)
      resolveCode?.(code)
    },
  }

  return {
    route,
    waitForCode: () => new Promise<string>((resolve, reject) => {
      resolveCode = resolve
      rejectCode = reject
    }),
  }
}
